export const localeSelector = (_lang, _country) => {

    let code = '';
    switch ( _lang ) {
        case "ko":
            code = 'ko-KR';
            break;
        case "en":
            code = 'en-US';
            break;
        case "ja":
            code = 'ja-JP';
            break;
        case "zh":
            code = 'zh-TW';
            break;
        case "vi":
            code = 'vi-VN';
            break;
        case "ru":
            code = 'ru-RU';
            break;
        case "ar":
            code = 'ar-AE';
            break;
        case "th":
            code = 'th-TH';
            break;
        case "id":
            code = 'id-ID';
            break;
        default:
            code = 'ko-KR';
    }

    return code;
}
